<ng-template #customViewTemplate class="custom-view-layout">
  <app-tab-customview
    #customViewInstance
    (onChange)="onCustomViewChange($event)"
    [value]="{
      component: {
        Configuration: {
          componentValue: {
            dataSourceQueryId: _value.component?.Configuration?.componentValue?.dataSourceQueryId,
            targetComponent: _value.component?.key,
            targetComponentScreen: _value.component?.screen,
            targetComponentType: 1,
            isUserPersonalizationSupported: true,
            enableFavoriteRecords: _value.component?.Configuration?.componentValue?.enableFavoriteRecords,
            enableSystemViews: _value.component?.Configuration?.componentValue?.enableSystemViews
          }
        }
      }
    }"
  ></app-tab-customview>
</ng-template>

<!-- Export Dropdown Template -->
<ng-template #exportDropdownTemplate>
  <button 
    class="export-dropdown-button"
    ejs-dropdownbutton 
    [items]="exportItems" 
    content="Export" 
    cssClass="export-dropdown" 
    (select)="onExportSelect($event)"
  ></button>
</ng-template>

<!-- Action Column Template with Favorite Star -->
<ng-template #actionTemplate let-data>
  <div class="action-cell" [class.context-menu-active]="isContextMenuOpen && activeRow[currentPrimaryKeyField] === data[currentPrimaryKeyField]">
    @if (_value.component?.Configuration?.componentValue?.enableFavoriteRecords) {
      <span 
        class="favorite-record-star" 
        [class.filled]="data?._isFavorite"
        (click)="toggleFavorite(data, $event)"
      >
        <i [class]="data?._isFavorite ? 'fa fa-star' : 'far fa-star'"></i>
      </span>
    }

    @if(contextMenuItems.length > 0) {
      <button 
        class="action-dot-btn" 
        (click)="onActionDotClick($event, data)"
      >
        <i class="fa fa-ellipsis-h"></i>
      </button>
    }
  </div>
</ng-template>

@if (_value.component?.Configuration?.componentValue?.allowNestedGridSupport && isShowGrid) {
  <ejs-treegrid
    [id]="gridUniqueId"
    #gridInstance
    [parentIdMapping]="_value.component?.Configuration?.componentValue?.nestedGridParentMappingField?.FieldName"
    [idMapping]="_value.component?.Configuration?.componentValue?.nestedGridValueMappingField?.FieldName"
    [treeColumnIndex]="treeColumnIndex"
    [enableCollapseAll]="true"
    [dataSource]="gridData ? gridData : []"
    [columns]="gridColumns ? gridColumns : []"
    [height]="
      _value.component?.Configuration?.componentValue?.gridHeight ?
      _value.component?.Configuration?.componentValue?.gridHeight :  gridHeight
    "
    [width]="
      _value.component?.Configuration?.componentValue?.gridWidth ?
      _value.component?.Configuration?.componentValue?.gridWidth:  'auto'
    "
    [searchSettings]="searchSettings"
    [sortSettings]="sortSettings"
    [filterSettings]="filterSettings"
    [pageSettings]="pageSettings"
    [editSettings]="editOptions"
    [selectionSettings]="selectionOptions"
    [toolbar]="toolbarItems"
    [contextMenuItems]="contextMenuItems"
    [showColumnMenu]="_value.component?.Configuration?.componentValue?.isShowColumnMenu"
    [showColumnChooser]="_value.component?.Configuration?.componentValue?.isShowColumChooser"
    [allowPaging]="_value.component?.Configuration?.componentValue?.isPageable"
    [allowSorting]="_value.component?.Configuration?.componentValue?.isSortable"
    [allowFiltering]="_value.component?.Configuration?.componentValue?.isAllowFilter"
    [allowReordering]="_value.component?.Configuration?.componentValue?.isAllowReorder"
    [allowRowDragAndDrop]="_value.component?.Configuration?.componentValue?.isAllowRowDragAndDrop"
    [allowResizing]="_value.component?.Configuration?.componentValue?.isAllowResizing"
    [allowExcelExport]="true"
    [allowPdfExport]="true"
    (toolbarClick)="toolbarClick($event)"
    (commandClick)="commandClick($event)"
    (rowSelected)="rowSelected($event)"
    (rowDrop)="rowDrop($event)"
    (expanded)="expanded($event)"
    (collapsed)="collapsed($event)"
    (dataStateChange)="dataStateChange($event)"
    (actionBegin)="actionBegin($event)"
    (created)="created($event)"
    (dataBound)="dataBound()"
    (contextMenuClick)="contextMenuClick($event)"
    (contextMenuOpen)="contextMenuOpen($event)"
    (cellSave)="cellSave($event)"
    (recordDoubleClick)="recordDoubleClick($event)"
    (actionComplete)="actionComplete($event)"
    (queryCellInfo)="queryCellInfo($event)"
  ></ejs-treegrid>
}

@if (!_value.component?.Configuration?.componentValue?.allowNestedGridSupport && isShowGrid) {
  <ejs-grid
    [id]="gridUniqueId"
    #gridInstance
    [dataSource]="gridData ? gridData : []"
    [columns]="gridColumns ? gridColumns : []"
    [height]="
      _value.component?.Configuration?.componentValue?.gridHeight ?
      _value.component?.Configuration?.componentValue?.gridHeight :  gridHeight
    "
    [width]="
      _value.component?.Configuration?.componentValue?.gridWidth ?
      _value.component?.Configuration?.componentValue?.gridWidth:  'auto'
    "
    [searchSettings]="searchSettings"
    [sortSettings]="sortSettings"
    [filterSettings]="filterSettings"
    [pageSettings]="pageSettings"
    [editSettings]="editOptions"
    [selectionSettings]="selectionOptions"
    [toolbar]="toolbarItems"
    [contextMenuItems]="contextMenuItems"
    [showColumnChooser]="_value.component?.Configuration?.componentValue?.isShowColumChooser"
    [allowPaging]="_value.component?.Configuration?.componentValue?.isPageable"
    [allowSorting]="_value.component?.Configuration?.componentValue?.isSortable"
    [allowFiltering]="_value.component?.Configuration?.componentValue?.isAllowFilter"
    [allowGrouping]="_value.component?.Configuration?.componentValue?.isAllowGrouping"
    [allowRowDragAndDrop]="_value.component?.Configuration?.componentValue?.isAllowRowDragAndDrop"
    [allowExcelExport]="true"
    [allowPdfExport]="true"
    [allowResizing]="_value.component?.Configuration?.componentValue?.isAllowResizing"
    [allowReordering]="_value.component?.Configuration?.componentValue?.isAllowReorder"
    [showColumnMenu]="_value.component?.Configuration?.componentValue?.isShowColumnMenu"
    [columnMenuItems]="columnMenuItems"
    (created)="created($event)"
    (dataBound)="dataBound()"
    (rowDrop)="rowDrop($event)"
    (toolbarClick)="toolbarClick($event)"
    (commandClick)="commandClick($event)"
    (actionBegin)="actionBegin($event)"
    (rowSelected)="rowSelected($event)"
    (dataStateChange)="dataStateChange($event)"
    (contextMenuClick)="contextMenuClick($event)"
    (contextMenuOpen)="contextMenuOpen($event)"
    (recordDoubleClick)="recordDoubleClick($event)"
    (actionComplete)="actionComplete($event)"
  >
    <!-- Template for empty record-->
    <ng-template #emptyRecordTemplate>
      <div class="no-record-found">
        <span></span>
        <div>There is no data available to display at the moment.</div>
      </div>
    </ng-template>
  </ejs-grid>
}

<div #extensionComponentRootInstance></div>